import type { QrBarcodeBlockConfig } from '@lighthouse/core'
import { QrBarcodeEnum } from '@lighthouse/core'

/**
 * 生成图片block的配置
 *
 * @returns {QrBarcodeBlockConfig}
 */
export const generateQrBarcodeBlock = (mainBreakPoint: string): QrBarcodeBlockConfig => {
    return {
        codeType: QrBarcodeEnum.QR_CODE,
        content: { value: undefined },
        barWidth: 1,
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 'fill'
                },
                height: {
                    size: 'auto'
                },
                overflow: 'visible'
            },
            layout: {}
        },
        breakPoints: []
    }
}
